/*新版功能管理中心*/

class Register_center_new {

  constructor() {
    /*模块功能注册*/
    this.curFuncId = '';//当前功能id
    this.curFuncObj =  "";//当前功能对象
    this.funcArr = [];//功能对象数组，
  }

  /**
   * 模块功能注册
   * @param {String} funcId 功能名称
   * @param {Object} funcObj  功能对象
   */
  registerFunc(funcId, funcObj) {
    /*如果注册过该funcId，则更新为最新注册实例funcObj*/
    let is_funcId_exist = this.funcArr.find(item => {return item.funcId == funcId });
    if(is_funcId_exist){
      is_funcId_exist.funcObj = funcObj;
    }else{
      this.funcArr.push({'funcId': funcId, 'funcObj': funcObj});
    }
  }

  /**
   * 重新初始化模块注册中心
   */
  resetFuncMenu(){
    this.curFuncId = '';
    this.curFuncObj = "";
    this.funcArr = [];
  }

  /**
   * 返回所有已注册的功能名称
   * @returns {Array}
   */
  getRegisteredNames(){
    let res = [];
    this.funcArr.forEach(item => {res.push(item.funcId)});
    return res;
  }

  /**
   * 模块功能激活
   * @param funcId  功能名称
   * @param handleRepeatFun  重复点击是否关闭
   * @param method  重复点击情况下执行的回调函数
   * @param option  配置项
   * @returns {string}
   */
  activeFunc(funcId,option) {
    let option_default = {handleRepeatFun:true,method:"",repeat_do:false};//默认配置项
    Object.assign(option_default,option);


    //找funcId对应的功能对象
    let funcObj = this.funcArr.find(item => {return item.funcId === funcId;});

    //功能未注册
    if (!funcObj) {return `无${funcId}功能!`;}

    //处理功能重复点击情况的处理
    if (funcObj.funcId == this.curFuncId ) {

      /*重复_继续执行激活*/
      if(option_default.repeat_do){
        funcObj.funcObj.active(option);
        if(option_default.method){
          method();
        }
        return
      }

      /*重复_关闭当前功能*/
      if(option_default.handleRepeatFun){
        //重复点击，则关闭当前激活的功能
        this.inActiveCurModule()
        if(option_default.method){
          method();
        }
      }
      //否则不做反应
      return;
    }

    /*卸载当前已激活的功能*/
    this.inActiveCurModule();
    this.curFuncId = funcId;
    this.curFuncObj = funcObj;

    /*激活本次需要的功能*/
    funcObj.funcObj.active(option);
  }


  active_func_by_id(func_id,option){
    if(!func_id){
      return
    }

    //找funcId对应的功能对象
    let funcObj = this.funcArr.find(item => {return item.funcId === func_id;});

    if(funcObj && funcObj.funcObj){
      funcObj.funcObj.active(option);
    }else{
      window.vue.GLOBAL.common_tool.warning('未找到' + func_id)
    }


  }

  /**
   * 卸载当前模块
   */
  inActiveCurModule() {
    if (this.curFuncObj) {
      this.curFuncObj.funcObj.inActive();
      this.curFuncId = "";
      this.curFuncObj = "";
    }
  }

  /**
   * 根据功能id卸载对应模块
   */
  inActive_module_by_id(id) {
    if(!id){return}
    /*如果是当前功能，则卸载当前功能*/
    if(id == this.curFuncId){
      this.inActiveCurModule()
      return;
    }

    let cur_func = this.getFuncById(id)
    if(cur_func){
      cur_func.funcObj.inActive();
    }
  }

  /**
   * 通过功能ID查找功能实例
   * @param funcId
   */
  getFuncById(funcId){
    if(funcId){
      return this.funcArr.find(item => {return item.funcId === funcId});
    }
    return "";
  }

  /**
   * 执行当前功能的Clear函数
   */
  clearCurrent() {
    if (this.curFuncObj && this.curFuncObj.funcObj.clear) {
      this.curFuncObj.funcObj.clear();
    }
  }

  /**
   * 获取当前激活状态功能的ID
   */
  getCurFuncObj() {
    return this.curFuncObj;
  }

  /**
   * 获取当前激活功能的ID
   * @returns {string}
   */
  getCurFuncId(){
    return this.curFuncId;
  }

  /**
   * 通过功能ID执行该功能的clear函数
   * @param  param 空或者非空,
   */
  clearByFuncId(funcId) {
    if (funcId) {
      let res = this.getFuncById(funcId);
      if(res && res.funcObj.clear){
        res.funcObj.clear();
      }
    }
  }

}

export default Register_center_new



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/register_center_new.js